/** @jsx jsx */

import { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { css, jsx } from '@emotion/core';

//

interface TextAreaDynamicHeightProps {
  minHeight?: number | undefined;
  maxLinesBeforeScrolling?: number | undefined;
  // maxHeightBeforeScrolling?: number | undefined;
  style?: { [key: string]: string | number };
  initialValue?: string | undefined;
  placeholder?: string;
  onUpdate?: (value: string) => void | undefined;
}

export const TextAreaDynamicHeight = (props: TextAreaDynamicHeightProps) => {
  const {
    minHeight = 30,
    maxLinesBeforeScrolling,
    // maxHeightBeforeScrolling,
    onUpdate,
    style = {},
    initialValue = '',
    placeholder = 'Type your message here...',
    ...rest
  } = props;

  const [init, setInit] = useState(false);
  const [characterHeightMeasured, setCharacterHeightMeasured] = useState(0);
  const [value, setValue] = useState(initialValue);

  const characterHeight = useRef<HTMLDivElement>(null);
  const proxy = useRef<HTMLDivElement>(null);
  const textArea = useRef<HTMLTextAreaElement>(null);

  const _style_: any = {
    all: 'unset',
    width: '100%',
    whiteSpace: 'pre-wrap',
    ...style,
  };

  let computedStyles = {
    fontFamily: 'inherit',
    fontSize: '0px',
    paddingTop: '0px',
    paddingBottom: '0px',
  };

  if (proxy?.current) {
    computedStyles = getComputedStyle(proxy?.current);
  }

  const computedFontFamily = computedStyles?.fontFamily;
  const computedFontSize = parseInt(computedStyles?.fontSize, 10);
  const paddingTop = parseInt(computedStyles?.paddingTop, 10);
  const paddingBottom = parseInt(computedStyles?.paddingBottom, 10);

  let maxHeight = maxLinesBeforeScrolling
    ? characterHeightMeasured * maxLinesBeforeScrolling +
      (paddingTop + paddingBottom)
    : '100%';

  useLayoutEffect(() => {
    characterHeight.current &&
      setCharacterHeightMeasured(characterHeight.current.scrollHeight);
  });

  useEffect(() => {
    if (textArea.current && value !== initialValue) {
      setValue(initialValue);
    }
    //
  }, [initialValue]);

  useEffect(() => {
    if (textArea.current && proxy.current && characterHeight.current) {
      setInit(true);
    }
  });

  return (
    <div
      style={{
        position: 'relative',
        visibility: init ? 'visible' : 'hidden',
        minHeight,
        maxHeight,
      }}
    >
      <div
        ref={characterHeight}
        style={{
          // all: 'unset',
          fontFamily: computedFontFamily,
          fontSize: computedFontSize,
          position: 'absolute',
          visibility: 'hidden',
        }}
      >
        Aa
      </div>
      <div
        ref={proxy}
        style={{
          ..._style_,
          visibility: 'hidden',
        }}
        dangerouslySetInnerHTML={{
          __html: `${value.replace(/\n/g, '<br />')}<br />`,
        }}
      ></div>
      <textarea
        ref={textArea}
        value={value}
        placeholder={placeholder}
        onChange={e => {
          const { value } = e.currentTarget;
          //
          setValue(value);
          onUpdate && onUpdate(value);
        }}
        style={{
          ..._style_,
          display: 'block',
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
        }}
        autoComplete="off"
        {...rest}
      />
    </div>
  );
};
